import React, { useState, useEffect, useRef } from 'react'
import './Carousel.css'
import Card from './Card'

const Carousel = ({ cards, active, onChange, onActiveClick }) => {
    const carouselDivRef = useRef(null)

    const handleScroll = (event) => {
        if (event.deltaY > 0) {
            let id = Math.min(active + 1, cards.length - 1)
            onChange(id)
        } else {
            let id = Math.max(active - 1, 0)
            onChange(id)
        }
    }

    useEffect(() => {
        const carouselDiv = carouselDivRef.current
        if (!carouselDiv) return

        carouselDiv.addEventListener('wheel', handleScroll)

        return () => {
            carouselDiv.removeEventListener('wheel', handleScroll)
        }
    }, [active, cards, carouselDivRef.current])

    const getVisibleImages = () => {
        const leftImages = []
        const rightImages = []
        for (let i = 1; i <= 4; i++) {
            if (active - i >= 0) {
                leftImages.unshift(cards[active - i])
            }
            if (active + i < cards.length) {
                rightImages.push(cards[active + i])
            }
        }

        while (leftImages.length < 4) {
            leftImages.unshift(
                <Card
                    key={0 - leftImages.length}
                    url=""
                    name=""
                    height="215"
                    width="200"
                    curCard={``}
                    cardId={0 - leftImages.length}
                />
            )
        }
        return { leftImages, rightImages }
    }

    const { leftImages, rightImages } = getVisibleImages()

    const handelClickCard = (e) => {
        onActiveClick(active)
    }

    return (
        <div ref={carouselDivRef} className="carousel">
            <div className="image-container">
                {leftImages.map((inactiveCard, index) => (
                    <div key={index} className="inactive-1px cardParent-1px">
                        {inactiveCard}
                    </div>
                ))}

                <div
                    id="active-1px"
                    onClick={handelClickCard}
                    className="active-1px cardParent-1px"
                    cardId={active}
                >
                    {cards[active]}
                </div>
                {rightImages.map((inactiveCard, index) => (
                    <div key={index} className="inactive-1px cardParent-1px">
                        {inactiveCard}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Carousel
